// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"0ad13ae9f4fe7641a06e","966":"2796ca293e6c92590943"}[chunkId] + ".js";
};